export default __webpack_public_path__ + "static/Drop-off-Instructions-Icon@2x-46f05bf8ef1638ed101186a6707189a1.png";